import React from 'react';
import EducatorEvaluationsCompleted from './EducatorEvaluationsCompleted';
import EducatorEvaluationsCreated from './EducatorEvaluationsCreated';
import PercentEducatorEvaluationsCompleted from './PercentEducatorEvaluationsCompleted';

export default function EducatorsWithCompletedProjectGroup(props) {
  return (
    <>
      <PercentEducatorEvaluationsCompleted {...props} />
      <EducatorEvaluationsCompleted {...props} />
      <EducatorEvaluationsCreated {...props} />
    </>
  )
}
